import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

// import BookmarkPage from '../components/BookmarkPage.vue'
// import DetailPage from '../components/DetailPage.vue'
// import LoginPage from '../components/LoginPage.vue'
// import ProductItem from '../components/ProductItem.vue'
// import ProductList from '../components/ProductList.vue'
// import RegisterPage from '../components/RegisterPage.vue'
// import Navbar from '../views/Navbar.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path : '/customers/bookmarks',
    name : 'BookmarkPage',
    component: () => import(/* webpackChunkName: "about" */ '../components/BookmarkPage.vue')

  },
  {
    path : `/customers/detailpage/:id`,
    name : 'DetailPage',
    component: () => import(/* webpackChunkName: "about" */ '../components/DetailPage.vue')

  },
  {
    path : '/customers/login',
    name : 'LoginPage',
    component: () => import(/* webpackChunkName: "about" */ '../components/LoginPage.vue')

  },
  {
    path : '/customers/productitem/:id',
    name : 'ProductItem',
    component: () => import(/* webpackChunkName: "about" */ '../components/ProductItem.vue')

  },
  // {
  //   path : '/customers/productslist',
  //   name : 'ProductList',
  //   component: () => import(/* webpackChunkName: "about" */ '../components/ProductList.vue')

  // },
  {
    path : '/customers/register',
    name : 'RegisterPage',
    component: () => import(/* webpackChunkName: "about" */ '../components/RegisterPage.vue')

  }
  // {
  //   path: '/about',
  //   name: 'About',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  // }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  if (to.name == "BookmarkPage" && !localStorage.access_token)
    next({ name: "LoginPage" });
  else next();

  if (
    (to.name == "LoginPage" || to.name == "RegisterPage") &&
    localStorage.access_token
  )
    next({ name: "Home" });
  else next();
});


export default router
